import { getAuthHeaders } from './authHeaders';

/** Executa no servidor uma ação que mexe em pontos (POST /api/v2/me/acoes/:acao). */
export async function chamarAcaoServidor(acao: string, args: unknown[]): Promise<any> {
  const headers = await getAuthHeaders();
  const resposta = await fetch(`/api/v2/me/acoes/${acao}`, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify({ args })
  });
  const json = await resposta.json().catch(() => ({}));
  if (!resposta.ok) throw new Error(json.error || `Falha na ação ${acao} (HTTP ${resposta.status}).`);
  return json.data;
}
